/**
 * Gets the enum numeric value out of the property provided. Sometimes the type script enum value is a string (i.e. from our APIs).
 * @param val - the enum property to evaluate
 * @param enumType - the enum object
 */
export function getEnumValue<T>(val: string | number, enumType: T): number | undefined {
  if (typeof val === 'string') {
    return (enumType as { [K: string]: number })[val];
  }

  // value is a number, so return undefined if it is not a valid enum value
  if ((enumType as { [K: number]: number })[val] == null) {
    return undefined;
  }

  return val;
}

/**
 * Gets the enum string value out of the property provided.
 * @param val - the enum property to evaluate
 * @param enumType - the enum object
 */
export function getEnumString<T>(val: string | number, enumType: T): string | undefined {
  if (typeof val === 'number') {
    return (enumType as { [K: number]: string })[val];
  }

  // value is a string, so return undefined if it is not a valid enum value
  if ((enumType as { [K: string]: number })[val] == null) {
    return undefined;
  }

  return val;
}
